import { render, staticRenderFns } from "./CreateEditCC.vue?vue&type=template&id=e10c36c0&"
import script from "./CreateEditCC.vue?vue&type=script&lang=js&"
export * from "./CreateEditCC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports